import { OktaAuth } from '@okta/okta-auth-js';

export const oktaConfig = {
    issuer: 'https://team.windcreekconnect.com/oauth2/default',
    clientId: '0oa1i41s7zmhoXdIq358',
    redirectUri: window.location.origin + '/login/callback',
    pkce: true,
    tokenManager: {
        autoRenew: true
    },
};
